export default "/images/vendor/flag-icon-css/flags/4x3/lk.svg?593078c9718a2a7a20d6e8e2242eb739";